import { render, staticRenderFns } from "./d-book-bottom-actions.vue?vue&type=template&id=72b089af&scoped=true&"
import script from "./d-book-bottom-actions.vue?vue&type=script&lang=js&"
export * from "./d-book-bottom-actions.vue?vue&type=script&lang=js&"
import style0 from "./d-book-bottom-actions.vue?vue&type=style&index=0&id=72b089af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b089af",
  null
  
)

export default component.exports